import {cx} from '@emotion/css';
import React, {ReactElement, ReactNode} from 'react';
import {TextAlignment} from '@fo/shared/styles/variables/fonts';

import styles from './Headers.styles';

export enum HeaderType {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  H5 = 'h5',
  H6 = 'h6',
}

export interface HeadersProps {
  alignment?: TextAlignment;
  children: ReactNode;
  className?: string;
  headerType: HeaderType;
  id?: string;
  testId?: string;
}

function Headers({alignment, children, className, headerType, id, testId}: HeadersProps): ReactElement {
  const HeaderTag = headerType;

  const headerClassName = cx('new-headers', styles.header(alignment), className);
  return (
    <HeaderTag className={headerClassName} id={id} data-testid={testId}>
      {children}
    </HeaderTag>
  );
}

export default Headers;
